import _toConsumableArray from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { Dimensions, StyleSheet } from 'react-native';
import { SceneView } from '@react-navigation/core';
import DrawerLayout from 'react-native-gesture-handler/DrawerLayout';
import { ScreenContainer } from 'react-native-screens';
import DrawerActions from '../routers/DrawerActions';
import DrawerSidebar from './DrawerSidebar';
import DrawerGestureContext from '../utils/DrawerGestureContext';
import ResourceSavingScene from '../views/ResourceSavingScene';
/**
 * Component that renders the drawer.
 */

var DrawerView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DrawerView, _React$PureComponent);

  function DrawerView() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DrawerView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DrawerView)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loaded: [_this.props.navigation.state.index],
      drawerWidth: typeof _this.props.navigationConfig.drawerWidth === 'function' ? _this.props.navigationConfig.drawerWidth() : _this.props.navigationConfig.drawerWidth
    });

    _defineProperty(_assertThisInitialized(_this), "drawerGestureRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "_handleDrawerStateChange", function (newState, willShow) {
      if (newState === 'Idle') {
        if (!_this.props.navigation.state.isDrawerIdle) {
          _this.props.navigation.dispatch({
            type: DrawerActions.MARK_DRAWER_IDLE,
            key: _this.props.navigation.state.key
          });
        }
      } else if (newState === 'Settling') {
        _this.props.navigation.dispatch({
          type: DrawerActions.MARK_DRAWER_SETTLING,
          key: _this.props.navigation.state.key,
          willShow: willShow
        });
      } else {
        if (_this.props.navigation.state.isDrawerIdle) {
          _this.props.navigation.dispatch({
            type: DrawerActions.MARK_DRAWER_ACTIVE,
            key: _this.props.navigation.state.key
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleDrawerOpen", function () {
      _this.props.navigation.dispatch({
        type: DrawerActions.DRAWER_OPENED,
        key: _this.props.navigation.state.key
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleDrawerClose", function () {
      _this.props.navigation.dispatch({
        type: DrawerActions.DRAWER_CLOSED,
        key: _this.props.navigation.state.key
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_updateWidth", function () {
      var drawerWidth = typeof _this.props.navigationConfig.drawerWidth === 'function' ? _this.props.navigationConfig.drawerWidth() : _this.props.navigationConfig.drawerWidth;

      if (_this.state.drawerWidth !== drawerWidth) {
        _this.setState({
          drawerWidth: drawerWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_renderNavigationView", function (drawerOpenProgress) {
      return React.createElement(DrawerGestureContext.Provider, {
        value: _this.drawerGestureRef
      }, React.createElement(DrawerSidebar, _extends({
        screenProps: _this.props.screenProps,
        drawerOpenProgress: drawerOpenProgress,
        navigation: _this.props.navigation,
        descriptors: _this.props.descriptors,
        contentComponent: _this.props.navigationConfig.contentComponent,
        contentOptions: _this.props.navigationConfig.contentOptions,
        drawerPosition: _this.props.navigationConfig.drawerPosition,
        style: _this.props.navigationConfig.style
      }, _this.props.navigationConfig)));
    });

    _defineProperty(_assertThisInitialized(_this), "_renderContent", function () {
      var _this$props = _this.props,
          lazy = _this$props.lazy,
          navigation = _this$props.navigation;
      var loaded = _this.state.loaded;
      var routes = navigation.state.routes;

      if (_this.props.navigationConfig.unmountInactiveRoutes) {
        var activeKey = navigation.state.routes[navigation.state.index].key;
        var descriptor = _this.props.descriptors[activeKey];
        return React.createElement(SceneView, {
          navigation: descriptor.navigation,
          screenProps: _this.props.screenProps,
          component: descriptor.getComponent()
        });
      } else {
        return React.createElement(ScreenContainer, {
          style: styles.pages
        }, routes.map(function (route, index) {
          if (lazy && !loaded.includes(index)) {
            // Don't render a screen if we've never navigated to it
            return null;
          }

          var isFocused = navigation.state.index === index;
          var descriptor = _this.props.descriptors[route.key];
          return React.createElement(ResourceSavingScene, {
            key: route.key,
            style: [StyleSheet.absoluteFill, {
              opacity: isFocused ? 1 : 0
            }],
            isVisible: isFocused
          }, React.createElement(SceneView, {
            navigation: descriptor.navigation,
            screenProps: _this.props.screenProps,
            component: descriptor.getComponent()
          }));
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_setDrawerGestureRef", function (ref) {
      _this.drawerGestureRef.current = ref;
    });

    return _this;
  }

  _createClass(DrawerView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Dimensions.addEventListener('change', this._updateWidth);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _this$props$navigatio = this.props.navigation.state,
          openId = _this$props$navigatio.openId,
          closeId = _this$props$navigatio.closeId,
          toggleId = _this$props$navigatio.toggleId,
          isDrawerOpen = _this$props$navigatio.isDrawerOpen;
      var _prevProps$navigation = prevProps.navigation.state,
          prevOpenId = _prevProps$navigation.openId,
          prevCloseId = _prevProps$navigation.closeId,
          prevToggleId = _prevProps$navigation.toggleId;
      var prevIds = [prevOpenId, prevCloseId, prevToggleId];
      var changedIds = [openId, closeId, toggleId].filter(function (id) {
        return !prevIds.includes(id);
      }).sort(function (a, b) {
        return a > b;
      });
      changedIds.forEach(function (id) {
        if (id === openId) {
          _this2._drawer.openDrawer();
        } else if (id === closeId) {
          _this2._drawer.closeDrawer();
        } else if (id === toggleId) {
          if (isDrawerOpen) {
            _this2._drawer.closeDrawer();
          } else {
            _this2._drawer.openDrawer();
          }
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Dimensions.removeEventListener('change', this._updateWidth);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var navigation = this.props.navigation;
      var activeKey = navigation.state.routes[navigation.state.index].key;
      var drawerLockMode = this.props.descriptors[activeKey].options.drawerLockMode;
      return React.createElement(DrawerLayout, {
        ref: function ref(c) {
          _this3._drawer = c;
        },
        onGestureRef: this._setDrawerGestureRef,
        drawerLockMode: drawerLockMode || this.props.screenProps && this.props.screenProps.drawerLockMode || this.props.navigationConfig.drawerLockMode,
        drawerBackgroundColor: this.props.navigationConfig.drawerBackgroundColor,
        keyboardDismissMode: this.props.navigationConfig.keyboardDismissMode,
        drawerWidth: this.state.drawerWidth,
        onDrawerOpen: this._handleDrawerOpen,
        onDrawerClose: this._handleDrawerClose,
        onDrawerStateChanged: this._handleDrawerStateChange,
        useNativeAnimations: this.props.navigationConfig.useNativeAnimations,
        renderNavigationView: this._renderNavigationView,
        drawerPosition: this.props.navigationConfig.drawerPosition === 'right' ? DrawerLayout.positions.Right : DrawerLayout.positions.Left
        /* props specific to react-native-gesture-handler/DrawerLayout */
        ,
        drawerType: this.props.navigationConfig.drawerType,
        edgeWidth: this.props.navigationConfig.edgeWidth,
        hideStatusBar: this.props.navigationConfig.hideStatusBar,
        statusBarAnimation: this.props.navigationConfig.statusBarAnimation,
        minSwipeDistance: this.props.navigationConfig.minSwipeDistance,
        overlayColor: this.props.navigationConfig.overlayColor,
        drawerContainerStyle: this.props.navigationConfig.drawerContainerStyle,
        contentContainerStyle: this.props.navigationConfig.contentContainerStyle
      }, React.createElement(DrawerGestureContext.Provider, {
        value: this.drawerGestureRef
      }, this._renderContent()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var index = nextProps.navigation.state.index;
      return {
        // Set the current tab to be loaded if it was not loaded before
        loaded: prevState.loaded.includes(index) ? prevState.loaded : [].concat(_toConsumableArray(prevState.loaded), [index])
      };
    }
  }]);

  return DrawerView;
}(React.PureComponent);

_defineProperty(DrawerView, "defaultProps", {
  lazy: true
});

export { DrawerView as default };
var styles = StyleSheet.create({
  pages: {
    flex: 1
  }
});